export default {
  getSelectedTopic: (state) => {
    return state.selectedTopic;
  },
};
